"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unitDependencies = void 0;
var _dependenciesUnitClassGenerated = require("./dependenciesUnitClass.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var unitDependencies = exports.unitDependencies = {
  UnitDependencies: _dependenciesUnitClassGenerated.UnitDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createUnitFunction: _factoriesAny.createUnitFunction
};